module.exports = "<!-- <button class=\"wg-icon\" md-button mdTooltip=\"{{ 'STOP' | tooltip }} \"  mdTooltipPosition=\"above\"  color='primary' (click)=\"stopCurrentSong()\">\n    <i class=\"material-icons icon stop\"></i>\n</button> -->\n\n<i class=\"fa fa-stop fa-x\" aria-hidden=\"true\" (click)=\"stopCurrentSong()\"></i>"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/stop-button/stop-button.component.html
// module id = ./src/app/player/stop-button/stop-button.component.html
// module chunks = main